import ApiClient from "services/ApiClient";
import qs from "qs";

import { formatSortField } from "utils/FormatUtils";

const PAGE_SIZE = 10;

class DashboardRecommendationsService extends ApiClient {
  getDashboardRecommendations({ page = 1, pageSize = PAGE_SIZE, sortBy, searchFilter }) {
    const query = {
      page,
      pageSize,
    };

    if (sortBy && sortBy.field && sortBy.direction !== "None") {
      query.SortFieldName = formatSortField(sortBy.field);
      query.SortDirection = sortBy.direction;
    }

    if (searchFilter) {
      query.ProjectName = searchFilter;
    }

    return this.call({
      method: "get",
      url: `/dashboard/recommendations?${qs.stringify(query)}`,
    });
  }
}

export default new DashboardRecommendationsService();
